<style lang="scss" scoped>
</style>

<template>
  <figure class="image">
    <div
      id="player"
      style="height: 405px;"
    />
  </figure>
</template>

<script>
export default {
  name: 'Embed',
  props: {
    videoId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      player: null,
      myregexp: /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/,
    };
  },
  computed: {
    parsedVideoId() {
      return this.videoId.match(this.myregexp)[5];
    },
  },
  beforeDestroy() {
    this.clearYoutubeScript();
  },
  created() {
    this.createYoutubeScript();
  },
  methods: {
    createYoutubeScript() {
      var tag = document.createElement('script');

      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
        this.onYouTubePlayerAPIReady();
      };
    },
    clearYoutubeScript() {
      let ytScript = document.querySelectorAll('script[src="https://www.youtube.com/iframe_api"');
      if(ytScript.length > 0) {
        ytScript[0].parentNode.removeChild(ytScript[0]);
      }
      window['YT'] = undefined;
      window['YTConfig'] = undefined;
    },
    onYouTubePlayerAPIReady() {
      console.log('ON READY');
      const vm = this;
      this.player = new YT.Player('player', {
        width: '640',
        height: '390',
        videoId: vm.parsedVideoId,
        playerVars: {rel: 0},
        events: {
          onReady: vm.onPlayerReady,
          onStateChange: vm.onPlayerStateChange,
        },
      });
    },

    onPlayerReady(event) {
      // event.target.playVideo();
    },
    onPlayerStateChange(event) {        
      if(event.data === 0) {          
        // alert('done');
        event.target.stopVideo();
      }
    },
  },
};
</script>